import { createContext, PropsWithChildren, useContext } from "react";

import {
    IBXPExpressClient,
    BXPExpressClient
} from "@atlassiansox/bxp-express-client";

const BXPExpressClientContext = createContext<IBXPExpressClient>(
    new BXPExpressClient()
);

export function useBXPExpressClient(): IBXPExpressClient {
    return useContext(BXPExpressClientContext);
}

export type BXPExpressClientProviderProps = PropsWithChildren<{
    readonly client: IBXPExpressClient;
}>;

export const BXPExpressClientProvider = ({
    client,
    children
}: BXPExpressClientProviderProps) => {
    return (
        <BXPExpressClientContext.Provider value={client}>
            {children}
        </BXPExpressClientContext.Provider>
    );
};
